import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { ChatForUser } from 'src/app/core/model/v2/chat/chat-for-user';
import { SaveChat, SaveChatMessage } from 'src/app/core/model/v2/chat/save-chat';
import { ChatService } from 'src/app/core/services/v2/chat.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-reply-message',
  templateUrl: './reply-message.component.html',
  styleUrls: ['./reply-message.component.scss']
})
export class ReplyMessageComponent implements OnInit {

  message: string;

  constructor(
    private chatService: ChatService,
    private snackBar: MatSnackBar,
    private loaderService: WindowLoaderService,
    public dialogRef: MatDialogRef<ReplyMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChatForUser) { }

  ngOnInit() {
  }

  sendMessage(): void {
    const newChatMessage = new SaveChat();
    newChatMessage.fromUserId = this.data.toUserId;
    newChatMessage.toUserId = this.data.fromUserId;

    const newMessages = new SaveChatMessage()
    newMessages.message = this.message;

    newChatMessage.messages = [];
    newChatMessage.messages.push(newMessages);

    this.loaderService.show();
    this.chatService.saveChat(newChatMessage).subscribe(
      (ret) => {
        if (ret.response.isSuccess) {
          this.snackBar.open('Message sent.', 'Ok');
        }
        this.loaderService.hide();
        this.dialogRef.close();
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    )
  }

  cancelMessage(): void {
    this.dialogRef.close();
  }

}
